import React from 'react';
import { Box, Typography, Paper, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import AddCardIcon from '@mui/icons-material/AddCard';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { formatCurrency, formatDateOnly } from '../../../utils/formatters';

const ServiceFinancials = ({ serviceRecord, payments, onAddPaymentClick, onDeletePayment }) => {
    return (
        <Paper sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>Cari Bilgisi</Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography>
                <b>Toplam:</b> {formatCurrency(serviceRecord.toplamTutar)}
            </Typography>
            <Typography color="success.main">
                <b>Ödenen:</b> {formatCurrency(serviceRecord.odenenTutar)}
            </Typography>
            <Typography color="error" variant="h6">
                <b>Kalan:</b> {formatCurrency(serviceRecord.kalanTutar)}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">Ödemeler</Typography>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<AddCardIcon />}
                    onClick={onAddPaymentClick}
                    className="no-print"
                >
                    Ödeme Ekle
                </Button>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Tarih</TableCell>
                            <TableCell>Yöntem</TableCell>
                            <TableCell align="right">Tutar</TableCell>
                            <TableCell className="no-print"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payments.map(p => (
                            <TableRow key={p.id}>
                                <TableCell>{formatDateOnly(p.tarih)}</TableCell>
                                <TableCell>{p.odemeYontemi}</TableCell>
                                <TableCell align="right">
                                    {formatCurrency(p.tutar)}
                                </TableCell>
                                <TableCell className="no-print">
                                    <IconButton size="small" color="error" onClick={() => onDeletePayment(p)}>
                                        <DeleteForeverIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ServiceFinancials;
